<template>
  <div
    id="app"
    class="w-100 h-100 bg-blue"
    :class="{
      completed,
      artworkVisible,
      showMenu,
    }"
    ref="app"
  >
    <div
      class="rotate-device w-100 h-100 bg-white z-999 absolute top-0 left-0 flex items-center justify-center flex-row"
    >
      <div
        class="flex flex-column w-80 center h-100 items-center justify-center"
      >
        <svg
          class="w-100"
          xmlns="http://www.w3.org/2000/svg"
          height="24"
          viewBox="0 0 24 24"
          width="24"
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path
            d="M16.48 2.52c3.27 1.55 5.61 4.72 5.97 8.48h1.5C23.44 4.84 18.29 0 12 0l-.66.03 3.81 3.81 1.33-1.32zm-6.25-.77c-.59-.59-1.54-.59-2.12 0L1.75 8.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75zm4.6 19.44L2.81 9.17l6.36-6.36 12.02 12.02-6.36 6.36zm-7.31.29C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32z"
          />
        </svg>
        <p class="w-100 tc measure">
          Please rotate your device to portrait mode for a better experience.
        </p>
      </div>
    </div>
    <div class="game-container w-100 h-100">
      <Menu
        :levels="levels"
        :levelsnames="levelsnames"
        :max-level="maxLevel"
        :currentlevel="level"
        class="menu w-100 flex-column pa0 ma0 overflow-scroll bg-white items-center justify-center"
        v-bind:class="{ menuvisible: showMenu }"
      />

      <Board v-if="!showMenu" :grid="grid" ref="board" :isInLine="isInLine"></Board>
      <div
        class="actions bg-white"
        v-bind:class="{
          bottomposition: showMenu,
          absolutebutton: !showMenu && !artworkVisible,
        }"
      >
        <div class="menu-zone justify-center">
          <div class="menuicon" v-if="!showMenu && !artworkVisible">
            <a
              href="#"
              class="backtomenu flex align-center no-underline black-70"
              @click="onShowMenu"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                version="1.1"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="M3 11H11V3H3M5 5H9V9H5M13 21H21V13H13M15 15H19V19H15M3 21H11V13H3M5 15H9V19H5M13 3V11H21V3M19 9H15V5H19Z"
                />
              </svg>
              <p class="f5-ns f6 pa0 ma0 self-center ml2">Menu</p>
            </a>
          </div>
          <div class="menuicon mr2" v-if="showMenu || artworkVisible">
            <a
              href="#"
              class="backtomenu flex align-center no-underline black-70"
              @click="onShowCrossWord"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="M10,4V8H14V4H10M16,4V8H20V4H16M16,10V14H20V10H16M16,16V20H20V16H16M14,20V16H10V20H14M8,20V16H4V20H8M8,14V10H4V14H8M8,8V4H4V8H8M10,14H14V10H10V14M4,2H20A2,2 0 0,1 22,4V20A2,2 0 0,1 20,22H4C2.92,22 2,21.1 2,20V4A2,2 0 0,1 4,2Z"
                />
              </svg>
              <p class="f5-ns f6 pa0 ma0 self-center ml2">Back to game</p>
            </a>
          </div>
          <div class="menuicon" v-if="artworkVisible">
            <a
              href="#"
              class="backtomenu flex align-center no-underline black-70"
              @click="onPreviewArtwork"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
                width="24"
              >
                <path d="M0 0h24v24H0z" fill="none" />
                <path
                  d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
                />
              </svg>
              <p class="f5-ns f6 pa0 ma0 self-center ml2">Learn more</p>
            </a>
          </div>
        </div>
      </div>
      <ImagesList
        v-if="!showMenu && !artworkVisible"
        :grid="grid"
        v-bind:artworkvisible="artworkVisible"
        class="h-20"
        :id="grid.id"
        :showTooltip="showTooltip"
      ></ImagesList>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Menu from "./components/Menu";
// import Audio from "./components/Audio";
import CardsStack from "./components/CardsStack";
import ImagesList from "./components/ImagesList";
import Board from "./components/Board";
import grids from "./grids";
import AxL from "./axl";

function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

// TRACKING TO ADD:
// [ ] - When an asset is dragged, whether it is dragged from the carousel to the board or from the board to another spot on the board or from the board to the carousel

export default {
  name: "App",
  provide: function() {
    return {
      getFirstImage: this.originalImages[0],
      getLevelDisplay: () => {
        return this.getLevel() + 1;
      },
      getImageByValue: (val) => {
        return this.grid.images.find((i) => i.url === val);
      },
      getMaxLevel: grids.length,
    };
  },
  methods: {
    onShare() {
      this.$root.$emit("game:share");
    },

    onShowMenu() {
      if (!this.showMenu) {
        this.artworkVisible = false;
        this.$root.$emit("menu:toggle");
        this.$root.$emit("image:hide");
        let validCells = 0;
        let allCells = this.grid.cells.length;
        this.grid.cells.forEach((element) => {
          if (element.isValid) {
            validCells++;
          }
        });
        const progression = (validCells * 100) / allCells;
        this.axl.sendMessage(AxL.ChildToHost.TRACK, {
          action: "show_menu",
          label: "game progression",
          value: progression,
        });
      }
    },

    onShowCrossWord() {
      console.log("show crossword!");
      if (this.showMenu) {
        this.$root.$emit("menu:toggle");
      }
      if (this.artworkVisible) {
        this.$root.$emit("image:hide");
      }
    },

    onShowArtWork() {
      if (this.showMenu) {
        this.$root.$emit("menu:toggle");
      }
      if (!this.artworkVisible) {
        console.log("show artwork!");
        this.$root.$emit("image:show", null, true);
      } else {
        console.log("artwork is already shown.");
      }
    },

    onPreviewArtwork() {
      console.log("preview artwork!", this.currentArtwork);
      this.axl.sendMessage(
        AxL.ChildToHost.NAVIGATE,
        "asset/" + this.currentArtwork.id
      );

      this.axl.sendMessage(AxL.ChildToHost.TRACK, {
        action: "navigate_to_asset",
        label: "asset_image",
        value: this.currentArtwork.id,
        nonInteraction: false,
      });
    },

    onHideArtwork() {
      console.log("hide artwork!");
      this.$root.$emit("image:hide");
    },

    getLevel: function() {
      return this.level;
    },

    checkValid: function() {
      if (this.grid.cells.every((c) => c.isValid)) {
        this.$root.$emit("board:completed");
        this.axl.storage.removeItem(`grid-${this.grid.id}`);
        this.axl.storage.removeItem(`grid-${this.grid.id}-started`);
      } else if (this.grid.cells.every((c) => c.value)) {
        this.$root.$emit("board:wronglycompleted");
      }
    },
  },
  updated: function() {
    if (window.matchMedia("screen and (min-width: 1000px)").matches) {
      const usedValues = this.grid.cells.map((c) => c.value).filter(Boolean);
      const unusedImages = this.grid.images.filter(
        (i) => !usedValues.includes(i.url)
      );
      //console.log("emit show!")
      //this.$root.$emit("image:show", unusedImages[0], true);
    }
  },
  mounted: function() {
    const portraitOrientationCheck = window.matchMedia(
      "(orientation: portrait)"
    );
    portraitOrientationCheck.addListener(() => {
      this.$forceUpdate();
    });

    document.addEventListener("keydown", (event) => {
      if (!event.ctrlKey) {
        return;
      }
      const keyName = event.key;
      switch (keyName) {
        case "1":
          this.$root.$emit("level:set", 0);
          break;
        case "2":
          this.$root.$emit("level:set", 1);
          break;
        case "3":
          this.$root.$emit("level:set", 2);
          break;
        case "4":
          this.$root.$emit("level:set", 3);
          break;
        case "5":
          this.$root.$emit("level:set", 4);
          break;
        case "6":
          this.$root.$emit("level:set", 5);
          break;
        case "7":
          this.$root.$emit("level:set", 6);
          break;
        case "8":
          this.$root.$emit("level:set", 7);
          break;
        case "9":
          this.$root.$emit("level:set", 8);
          break;
        case "0":
          this.$root.$emit("level:set", 9);
          break;
        case "m":
          this.showMenu = !this.showMenu;
          break;
        case "x":
          this.axl.storage.flush().then(() => {
            window.location.reload();
          });
          break;
      }
      console.log(keyName, event);
    });

    this.checkValid();
    // console.log("emit show!")
    // this.$root.$emit("image:show", this.grid.images[0], true);

    this.$root.$on("menu:toggle", () => {
      this.showMenu = !this.showMenu;
    });

    this.$root.$on("did:drag", ({ data, toRow, toCol }) => {
      let message = "";
      message = "From " + data.from + " to ";
      if (toRow) {
        message += "grid";
      } else {
        message += "list";
      }
      this.axl.sendMessage(AxL.ChildToHost.TRACK, {
        action: "drag",
        value: message,
      });
    });

    this.$root.$on("tooltip:hide", () => {
      this.axl.storage.setItem("tooltipViewed", true);
      this.showTooltip = false;
    });

    this.$root.$on("level:set", async (level) => {
      this.level = level;
      if (level > this.maxLevel) {
        this.axl.storage.setItem("maxLevel", level);
        this.maxLevel = level;
      }
      this.showMenu = false;
      this.axl.sendMessage(AxL.ChildToHost.TRACK, {
        action: "select_level",
        label: this.level,
      });
    });

    this.$root.$on("level:next", async () => {
      console.log("level:next");
      await this.axl.storage.removeItem(`grid-${this.grid.id}`);
      // This should not necessary, grids is not supposed to have changed…
      // But it does…
      // And there should be peace on earth…
      grids[this.level].cells.map((c) => {
        c.value = undefined;
        c.isValid = false;
      });

      this.level = this.level + 1;
      console.warn(this.level);
      const currentMax = (await this.axl.storage.getItem("maxLevel")) || 0;
      if (this.level > currentMax) {
        await this.axl.storage.setItem("maxLevel", this.level);
        console.warn(this.level);
        this.maxLevel = this.level;
      }
      this.axl.sendMessage(AxL.ChildToHost.TRACK, {
        action: "change_level",
        label: this.level,
      });
    });

    this.$root.$on("game:share", () => {
      this.axl.sendMessage(AxL.ChildToHost.SHARE, {
        title: `I made it to level ${this.level +
          1}. Join me on visual crossword`,
      });
      this.axl.sendMessage(AxL.ChildToHost.TRACK, {
        action: "share_game",
        label: "pop_up",
      });
    });

    this.$root.$on("board:completed", () => {
      this.completed = true;

      this.axl.sendMessage(AxL.ChildToHost.TRACK, {
        action: "complete_board",
        label: "isCorrect",
        value: true,
      });
    });

    this.$root.$on("board:wronglycompleted", () => {
      this.axl.sendMessage(AxL.ChildToHost.TRACK, {
        action: "complete_board",
        label: "isCorrect",
        value: false,
      });
    });

    this.$root.$on("image:show", (artwork, update) => {
      console.log("on show image!");
      if (update) {
        this.artworkVisible = true;
      }
      this.axl.sendMessage(AxL.ChildToHost.TRACK, {
        action: "select_asset",
        label: "asset_image",
        value: artwork,
      });
    });

    this.$root.$on("image:hide", () => {
      console.log("on hide image!");
      this.artworkVisible = false;
    });

    this.$root.$on("setcurrentimage", (image) => {
      this.currentArtwork = image;
    });

    this.$root.$on("cell:changed", async ({ row, col, img, thumbUrl }) => {
      const cell = this.grid.cells.find((c) => c.row === row && c.col === col);
      cell.value = img;
      cell.thumbUrl = thumbUrl;
      const cellWords = this.grid.words.filter((w) => {
        return cell.words.includes(w.hint);
      });
      const cellWordsValues = cellWords.map((cw) => cw.values);
      const imageCount = this.grid.words.filter((w) => {
        return w.values.some((v) => cell.value && cell.value.includes(v));
      }).length;
      const isCountValid = imageCount === cellWords.length;
      const isWordValid = cellWordsValues.every((values) => {
        return values.some((v) => cell.value && cell.value.includes(v));
      });
      const isValid = isWordValid && isCountValid;
      const newGrid = {
        ...this.grid,
        cells: [
          ...this.grid.cells.filter((c) => !(c.row === row && c.col === col)),
          {
            ...cell,
            isValid,
          },
        ],
      };
      this.grid = newGrid;
      this.axl.storage.setItem(`grid-${this.grid.id}`, this.grid);
      this.axl.storage.setItem("lastUpdate", Date.now());
      this.checkValid();

      // this.axl.sendMessage(AxL.ChildToHost.TRACK, {
      //   action: "drag",
      //   value: img
      // });
    });
  },
  props: {
    axl: Object,
    saved_level: Number,
    saved_maxLevel: Number,
    saved_grid: Object,
    tooltipViewed: Boolean,
    isInLine: Boolean,
  },
  data: function() {
    let names = [];
    grids.forEach((element) => {
      names.push(element.name);
    });
    const level = this.saved_level || 0;
    const grid = this.saved_grid || grids[level];
    const maxLevel = this.saved_maxLevel || level;
    shuffleArray(grid.images);

    return {
      showTooltip: !this.tooltipViewed,
      showMenu: false,
      isInLine: this.isInLine,
      level: level,
      levels: [...Array(grids.length).keys()],
      grid: grid,
      isLoading: true,
      levelsnames: names,
      completed: false,
      artworkVisible: false,
      currentArtwork: null,
      maxLevel: maxLevel,
      originalImages: [...grid.images],
    };
  },

  watch: {
    level: async function(newVal) {
      this.originalImages = [...grids[newVal].images];
      const id = grids[newVal].id;
      this.grid =
        (await this.axl.storage.getItem(`grid-${id}`)) || grids[newVal];
      shuffleArray(this.grid.images);
      this.completed = false;
      await this.axl.storage.setItem("currentLevel", newVal);
      await this.axl.storage.setItem("lastUpdate", Date.now());
      this.$root.$emit("level:changed");
    },
  },
  components: {
    Menu,
    ImagesList,
    // Audio,
    CardsStack,
    Board,
  },
};

// document.addEventListener(
//   "touchmove",
//   function(e) {
//     e.preventDefault();
//   },
//   { passive: false }
// );
</script>

<style>
@import "./static/tachyons.min.css";
</style>

<style>
html,
body {
  margin: 0;
  padding: 0;
  width: 100vw;
  height: 100vh;
  min-height: 100vh;
  min-height: -webkit-fill-available;
  background-color: white;
  /* overscroll-behavior-y: contain;
  position: fixed;
  overflow: hidden; */
  font-family: "Google Sans", Roboto, Arial, sans-serif;
}

html {
  height: -webkit-fill-available;
}

::-webkit-scrollbar {
  display: none;
  width: 0px;
  height: 0px;
  background: transparent;
}

#app {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  align-items: center;
  color: #000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100%;
  height: 100%;
  min-height: 100vh;
  min-height: -webkit-fill-available;
  max-height: -moz-available;
  max-height: stretch;
  width: 100vw;
  max-width: -webkit-fill-available;
  max-width: -moz-available;
  max-width: stretch;
  margin: 0 auto;
  overflow: hidden;
  padding: 0;
  background: white;
}

.rotate-device {
  display: none;
}

.rotate-device svg {
  height: 48px;
}

.paper > div {
  /* padding: 1rem; */
  background: #f5f5f5;
}

/* drag and drop image */
body > img {
  opacity: 0.5;
}
/* 
@media screen and (max-width: 1000px) {
  #app {
    overflow: hidden;
  }

  .paper {
    margin-top: 3rem;
  }
} */

.tooltip.valid {
  background: #1a73e8;
}

.interactions {
  z-index: 1;
  display: flex;
  justify-content: space-between;
  /* margin-top: 3rem; */
  padding-top: 2rem;
}

.cards-container {
  display: flex;
  flex: 1;
  width: 100%;
  background-color: white;
}

.bottomposition {
  position: absolute !important;
  bottom: 0px;
  width: 100%;
}

@media screen and (min-width: 1000px) {
  .cards-container {
    /* flex: 1; */
    width: 100%;
  }
}

button {
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  color: #fff;
  background-color: #1976d2;
  padding: 6px 16px;
  font-size: 0.875rem;
  min-width: 64px;
  box-sizing: border-box;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-family: "Google Sans", Roboto, Arial, sans-serif !important;
  font-weight: 500;
  line-height: 1.75;
  border-radius: 5px;
  letter-spacing: 0.02857em;
  text-transform: uppercase;
  border: none;
  cursor: pointer;
}

button:hover {
  background-color: rgb(17, 82, 147);
}

button:active {
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
    0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.topbar {
  width: 100vw;
  z-index: 2;
  color: #fff;
  background-color: #1976d2;
  display: flex;
}

.topbar h1 {
  font-size: 1.25rem;
}

.gameStarted .cards {
  margin: 0;
}

.cards-container {
  display: flex;
  width: 100vw;
  height: 100%;
  align-items: center;
  justify-content: center;
}

.cards {
  height: 85%;
}

.game-container {
  min-height: 100vh;
  height: 100%;
  min-height: -webkit-fill-available;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: white;
}

.icon {
  z-index: 12;
  background-color: white;
  position: relative;
  min-width: 44px;
  height: 44px;
  border-radius: 5px;
  cursor: pointer;
  border: none;
  overflow: hidden;
  transition: all 0.2s ease;
}

.menuicon svg {
  width: 24px;
  height: 24px;
  fill: #5f6368;
}

.share {
  display: flex;
  font-size: 25px;
  padding: 10px;
  margin: 0;
  border-radius: 5px;
  padding: 10px;
  z-index: 100;
  cursor: pointer;
}

.actions {
  position: relative;
  display: flex;
  height: 60px;
  z-index: 100;
  box-sizing: border-box;
}

.actions > div {
  flex: 1;
  display: flex;
  /* justify-content: flex-start; */
  align-items: center;
  padding: 0 0.6rem;
}

.backtomenu,
.backtogame {
  display: flex;
  font-size: 25px;
  padding: 10px;
  margin: 0;
  border-radius: 5px;
  padding: 10px;
  z-index: 100;
  cursor: pointer;
  height: 48px;
  transition: background-color 0.2s ease;
}

.backtomenu:hover {
  background-color: #eeeeee;
}

.backtomenu:active {
  background-color: #b6b6b6;
}

.share {
  background: white;
}

.actions .share-zone {
  background: white;
  display: flex;
  justify-content: flex-end;
}

@media screen and (max-width: 1000px) {
  .artworkVisible .menuicon,
  .artworkVisible .share {
    background: white;
  }

  .game-container {
    background: white;
  }

  .actions .share-zone {
    background: white;
  }

  .share {
    background: white;
  }
}

@media (orientation: landscape) and (hover: none) and (pointer: coarse) {
  @media screen and (max-height: 460px) {
    .rotate-device {
      display: block;
    }
  }

  .absolutebutton {
    position: absolute;
    bottom: 118px;
    background-color: transparent;
  }
  .actions {
    background-color: transparent;
  }

  .backtomenu,
  .backtogame {
    background-color: #eeeeee;
  }
}
</style>
